import React, { PureComponent, FunctionComponent } from "react";
import { IRepertoireStateKeys } from "../../types/IRepertoireStateKeys";
import { REPERTOIRE_PAGE_FORM_ITEM_SIZE } from "../../Consts";

export interface ICheckboxDataInputProps {
    label: string;
    value: any;
    changeData: (
        value: string | boolean,
        fieldName: IRepertoireStateKeys
    ) => void;
    fieldName: IRepertoireStateKeys;
    readonly?: boolean;
    isHidden?: boolean;
    inline?: boolean;
    key?: string;
    alignSelfCenter?: boolean;
    style?: React.CSSProperties;
    className?: string;
}

export const SizedCheckboxDataInput: FunctionComponent<ICheckboxDataInputProps> = (props: ICheckboxDataInputProps) => {

    const {
        isHidden,
        alignSelfCenter = false,
        style,
        className
    } = props;

    if (props.isHidden)
        return null;

    return <div className={`${props.className ? props.className : REPERTOIRE_PAGE_FORM_ITEM_SIZE} ${props.alignSelfCenter ? 'flexAlignSelfCenter' : ''}`} >
            <CheckboxDataInput {...props} />
    </div>

}

export default class CheckboxDataInput extends PureComponent<
    ICheckboxDataInputProps
> {
    constructor(props) {
        super(props);
    }

    render() {
        const { label, changeData, value, fieldName, readonly, isHidden, inline, key, style } = this.props;
        if (isHidden)
            return null;

        return (
            <div key={key} className={["checkboxContainer", inline && "inline"].join(" ")}
            style={style || undefined}
            >
                <label className="subContainer">
                    <input
                        className={"disabledItem"}
                        type={"checkbox"}
                        onChange={event => changeData(event.target.checked, fieldName)}
                        value={value || false}
                        checked={value || false}
                        disabled={readonly}
                        data-testid={fieldName}
                    />
                    <span className={["inputCheckbox", readonly ? "disabledItem" : ""].join(" ")} />
                    <div className={["checkboxLabel", readonly ? "disabledItem" : ""].join(" ")}>{label}</div>
                </label>
            </div>
        );
    }
}
